/** Frontmatter for the "week3-start-sit-darkness-report" article; the Body lives in week3-start-sit-darkness-report.jsx. */
const meta = {
  slug: 'week3-start-sit-darkness-report',
  title: 'Week 3 Start/Sit: The Darkness Report',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'All 15 Sunday and Monday games, one card each: the pick, start and sit calls, sleepers and IDP plays, plus an implied-points chart, a D/ST streaming board, the top IDP plays and the inactives checklist.',
  readMinutes: 18,
  date: '2026-09-25',
};

export default meta;
